import React, { Fragment, useState, useEffect, useRef } from "react";
import Breadcrumb from "../../component/common/breadcrumb/breadcrumb";
import { Container, Row, Col, Card, CardHeader, CardBody, Button } from "reactstrap";
import axios from "axios";
import $ from "jquery";
import "datatables.net";
import "datatables.net-bs5/css/dataTables.bootstrap5.min.css";
import * as XLSX from "xlsx";
const { jsPDF } = require('jspdf');
const { autoTable } = require('jspdf-autotable');

const ValetReports = () => {
    const token = localStorage.getItem("token");
    const valetId = localStorage.getItem("valetId");
    const userId = localStorage.getItem("userId");
    const tableRef = useRef(null);
    const [data, setData] = useState([]);

    useEffect(() => {
        if (token && tableRef.current) {
            const apiUrl = `${process.env.REACT_APP_PUBLIC_SERVER}/api/valet-reports`;
            console.log(valetId);
            const dataTable = $(tableRef.current).DataTable({
                ajax: {
                    url: apiUrl,
                    type: "GET",
                    headers: { Authorization: `Bearer ${token}` },
                    data:{
                        user:{
                            id:(valetId !== "null"?valetId:userId),
                            isBoss:(valetId == null)
                        }
                    },
                    dataSrc:''
                },
                columns: [
                    { title: "Valet", data: "valet_name" },
                    { title: "Cliente", data: "customer_name" },
                    { title: "Declaración de Objetos", data: "object_declaration" },
                    { title: "GPS Inicial", data: "initial_gps" },
                    { title: "GPS Final", data: "end_gps" },
                    { title: "Propina", data: "tip_to_valet" },
                    { title: "Método de Pago", data: "payment_method" },
                    { title: "Estado", data: "status" },
                    {
                        title: "Fecha de Inicio",
                        data: "created_at",
                        render: (data) => new Date(data).toLocaleString()
                    },
                ],
                responsive: true,
                dom: 'Bfrtip',
                buttons: [
                    {
                        extend: 'excelHtml5',
                        text: 'Exportar a Excel',
                        className: 'btn btn-success',
                    },
                    {
                        extend: 'pdfHtml5',
                        text: 'Exportar a PDF',
                        className: 'btn btn-danger',
                    },
                ],
                initComplete: function () {
                    this.api().columns().every(function () {
                        var column = this;
                        var select = $('<select><option value=""></option></select>')
                            .appendTo($(column.footer()).empty())
                            .on('change', function () {
                                var val = $.fn.dataTable.util.escapeRegex($(this).val());
                                column.search(val ? '^' + val + '$' : '', true, false).draw();
                            });

                        column.data().unique().sort().each(function (d, j) {
                            select.append('<option value="' + d + '">' + d + '</option>');
                        });
                    });
                },
            });

            return () => {
                if (dataTable) {
                    dataTable.destroy();
                }
            };
        }
    }, [token]);

    const exportToPDF = () => {
        const doc = new jsPDF('l', 'pt', 'a4');
        //doc.text("Reportes de Valets", 14, 16);
        const source = document.getElementById("report");
        source.deleteTFoot();
        // all coords and widths are in jsPDF instance's declared units
        // 'inches' in this case
        doc.html(
            source, // HTML string or DOM elem ref.
            {
                callback: function (doc) {
                    doc.save();
                },
                x: 10,
                y: 10,
                width:900,
                windowWidth:900
            });
        //doc.save("reportes_valets.pdf");
    };

    const exportToExcel = () => {
        const worksheet = XLSX.utils.json_to_sheet(data.map(row => ({
            Valet: row.valet_name,
            Cliente: row.customer_name,
            'Declaración de Objetos': row.object_declaration,
            'GPS Inicial': row.initial_gps,
            'GPS Final': row.end_gps,
            Propina: row.tip_to_valet,
            'Método de Pago': row.payment_method,
            Estado: row.status,
            'Fecha de Inicio': new Date(row.created_at).toLocaleString()
        })));
        //const workbook = XLSX.utils.book_new();
        const table = document.getElementById("report");
        table.deleteTFoot();
        const workbook = XLSX.utils.table_to_book(table);
        //XLSX.utils.book_append_sheet(workbook, worksheet, "Reportes");
        XLSX.writeFile(workbook, "reportes_valets.xlsx");
    };

    return (
        <Fragment>
            <Breadcrumb parent="Dashboard" title="Reportes de Valets" />
            <Container fluid={true}>
                <Row>
                    <Col sm="12">
                        <Card>
                            <CardHeader>
                                <h5>Reportes de Valets</h5>
                                <div className="mt-2">
                                    <Button color="success" onClick={exportToExcel} className="me-2">
                                        Exportar a Excel
                                    </Button>
                                </div>
                            </CardHeader>
                            <CardBody>
                                <table ref={tableRef} id="report" className="table table-striped nowrap" style={{ width: "100%" }}>
                                    <thead>
                                        <tr>
                                            <th>Valet</th>
                                            <th>Cliente</th>
                                            <th>Declaración de Objetos</th>
                                            <th>GPS Inicial</th>
                                            <th>GPS Final</th>
                                            <th>Propina</th>
                                            <th>Método de Pago</th>
                                            <th>Estado</th>
                                            <th>Fecha de Inicio</th>
                                        </tr>
                                    </thead>
                                    <tfoot>
                                    <tr>
                                        <th>Valet</th>
                                        <th>Cliente</th>
                                        <th>Declaración de Objetos</th>
                                        <th>GPS Inicial</th>
                                        <th>GPS Final</th>
                                        <th>Propina</th>
                                        <th>Método de Pago</th>
                                        <th>Estado</th>
                                        <th>Fecha de Inicio</th>
                                    </tr>
                                    </tfoot>
                                </table>
                            </CardBody>
                        </Card>
                    </Col>
                </Row>
            </Container>
        </Fragment>
    );
};

export default ValetReports;
